/* global $ */

export default class AbstractScrollTo {
  scrollTo(elem, speed) {
    $('html, body').animate({ scrollTop: elem }, speed)
  }
}
